<template>
<ValidationObserver ref="observer">
  <form ref="add_cashier_form" @submit.prevent="addCashier">

    <md-card>
         
      <md-card-content>

        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
          <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="drivername" v-slot="{ errors }">
            <md-field  class="md-invalid">
              <label>Driver Name</label>
              <md-input v-model="driver_name_text" required readonly/>
              <md-button style="background-color:green;" class="md-icon-button md-info md-dense" v-on:click="findDriver">
                <md-icon >search</md-icon>
              </md-button>
              <validation-error :errors="apiValidationErrors.driver_name_text" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>KIP No</label>
              <md-input :disabled="!driver_name_text" v-model="driver_kip_no_text" readonly/>
              <validation-error :errors="apiValidationErrors.driver_kip_no_text" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          </div>
          <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="paymentmethod" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Payment Method</label>
              <md-select :disabled="!driver_name_text"  v-model="payment_method" required >
                <md-option value="1" :selected="payment_method === 1">Cash</md-option>
                <md-option value="2" :selected="payment_method === 2">Bank Transfer</md-option>
                <!-- <md-option value="3" :selected="payment_method === 3">EDC Payment</md-option>
                <md-option value="4" :selected="payment_method === 4">Virtual Account</md-option> -->
              </md-select>
              <validation-error :errors="apiValidationErrors.payment_method" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="cashiername" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Cashier</label>
              <md-input v-model="payment_cashier_name"  required readonly/>
              <validation-error :errors="apiValidationErrors.payment_cashier_name" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          </div>

          <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="pool" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Pool</label>
              <md-select :disabled="!driver_name_text" v-model="payment_pool_id" required>
                <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                  {{ option.pool_name }}
                </md-option>
                  </md-select>
              <validation-error :errors="apiValidationErrors.payment_pool_id" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="paymentdate" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Payment Date</label>
              <md-input :disabled="!driver_name_text"  type="date" v-model="payment_at" required/>
              <validation-error :errors="apiValidationErrors.payment_at" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          </div>
          <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="paymentreceive" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Payment Amount</label>
              <md-input  :disabled="!driver_name_text || !payment_method"  type="text" v-on:keypress="NumbersOnly" @wheel="$event.target.blur()"  v-model="payment_receive_amount" min=1 oninput="validity.valid||(value='');" required />
              <validation-error :errors="apiValidationErrors.payment_receive_amount" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider  v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Billing Amount</label>
              <md-input v-model="payment_billing_amount"  required readonly/>
              <validation-error :errors="apiValidationErrors.payment_billing_amount" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
          </div>
        <!-- </div> -->

        <div class="md-layout" v-if="payment_method == 2">
          <div class="md-layout-item md-size-50 md-small-size-100" >
            <!-- <validation-provider   :rules="{transferno:payment_method}" v-slot="{ errors }"> -->
            <md-field class="md-invalid">
              <label>Transfer No.</label>
              <!-- <md-input  type="text" v-on:keypress="NumbersOnly" v-model="payment_transfer_no" :required="payment_method == 1" :disabled="!driver_name_text && payment_method != 2" /> -->
              <!-- <validation-error :errors="apiValidationErrors.payment_transfer_no" /> -->
              <md-input  type="text" v-on:keypress="NumbersOnly" v-model="payment_transfer_no" :disabled="!driver_name_text && payment_method != 2" />
              <!-- <span class="md-error">{{ errors[0] }}</span> -->
            </md-field>
            <!-- </validation-provider> -->
          </div>
          </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-textarea :disabled="!driver_name_text"  v-model="payment_remark" md-counter="255" maxlength="255" md-autogrow></md-textarea>
                  <validation-error
                    :errors="apiValidationErrors.payment_remark"
                  />
                  <md-avatar >
                    <md-icon style="color:blue;">report</md-icon>
                    <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                  </md-avatar>
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
            </div>
        
        
        <label v-if="payment_type_enable" class="md-layout-item md-size-15 md-form-label" style="margin-left:20px;">Payment Type</label>
        <div class="md-layout">
          
          <div  class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="paymenttype" v-slot="{ errors }">
                
                  
                  <md-radio :disabled="!(payment_type_enable && payment_type_enable.biling_dp)" v-model="payment_type" value="dp">Driver DP</md-radio>
                  <md-radio :disabled="!(payment_type_enable && payment_type_enable.biling_spj)"  v-model="payment_type" value="weekly">Weeekly Payment</md-radio>
                  <md-radio :disabled="!(payment_type_enable && payment_type_enable.biling_additional_fee)"  v-model="payment_type" value="additional_fee">Additional Fee</md-radio>
                  <span class="md-error" style="color:red;">{{ errors[0] }}</span>
                
              </validation-provider>
          </div>
        </div>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
          <div class="md-layout-item md-small-size-100" v-if="payment_type == 'additional_fee'">
            <md-card v-if="billing_info">
              <md-card-header class="md-card-header-text md-card-header-blue">
                <div class="card-text">
                  <h4 class="title">Additional Fee List</h4>
                </div>
              </md-card-header>
              <md-card-content >
                <v-data-table
                  mobile-breakpoint
                  :headers="AdditionalFeeHeaders"
                  :items="ListAdditionalFeeTable"
                  loading-text="Loading... Please wait"
                  ref="vTable"
                  height="150"
                  fixed-header
                >
                  <template v-slot:item="{ item }">
                    <tr @click="onSelectListAdditionalFee(item)">
                      <td>{{ item.name }}</td>
                      <td>
                        <span v-if="item.type == 1">Repair</span>
                        <span v-if="item.type == 2">Penalty</span>
                        <span v-if="item.type == 3">Repo</span>
                        <span v-if="item.type == 4">OOJ</span>
                        <span v-if="item.type == 5">STNK extension</span>
                        <span v-if="item.type == 6">Remaining PKO Payments</span>
                      </td>
                      <td>Rp. {{ formatPrice(item.billing_amount) }}</td>
                      <td>Rp. {{ formatPrice(item.paid_amount) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </md-card-content>

                </md-card>

          </div>
          <div class="md-layout-item md-small-size-100">
            <md-card v-if="billing_info">
              <md-card-header class="md-card-header-text md-card-header-blue">
                <div class="card-text">
                  <h4 class="title">Billing Info</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;">Ref No</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell >{{billing_info.ref_no}}</md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="payment_type == 'dp'">
                    <md-table-cell style="font-weight:bold;">Amount</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell >
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(billing_info.amount)}}</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="payment_type == 'weekly'">
                    <md-table-cell style="font-weight:bold;">Start Date</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell >{{new Date(billing_info.start_date).toDateString()}}
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="payment_type == 'weekly'">
                    <md-table-cell style="font-weight:bold;">Due Date</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell >{{new Date(billing_info.due_date).toDateString()}}
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="payment_type == 'weekly'">
                    <md-table-cell style="font-weight:bold;">Amount Weekly</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell >
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(billing_info.amount_weekly)}}</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="payment_type == 'weekly'">
                    <md-table-cell style="font-weight:bold;">Amount Penalty</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell >
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(billing_info.amount_penalty)}}</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;">Paid Amount</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell v-if="billing_info.paid_amount">
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(billing_info.paid_amount)}}</span>
                    </md-table-cell>
                    <md-table-cell v-else>
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(0)}}</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;">Billing Amount</md-table-cell>
                    <md-table-cell>:</md-table-cell>
                    <md-table-cell v-if="billing_info.billing_amount">
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(billing_info.billing_amount)}}</span>
                    </md-table-cell>
                    <md-table-cell v-else>
                      <span style="float:left;">Rp.</span>
                      <span style="float:right; margin-right:50mm;">{{formatPrice(0)}}</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>

                </md-card>

          </div>
          </div>
           

        </div>

          

        
      </md-card-content>
      
      <modal ref="modalListDriver" class="coba">
        <template v-slot:header>
          <div>
            <h3>List Driver</h3>
          </div>
        <md-button class="md-dense md-round md-icon-button" @click="CloseList()"><md-icon>close</md-icon></md-button>
        </template>
        <template v-slot:body>
          <list-driver :data_id="$refs.modalListDriver.data"/>
        </template>
      </modal>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <!-- <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button> -->
      </md-card-actions>

          <!-- <md-card-content v-if="billing_info">
             <label>Billing Info</label>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label>Ref No.</label>
                  <md-input v-model="billing_info.ref_no" readonly/>
                </md-field>
              </div>
              <div v-if="payment_type == 'dp'" class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label>Amount</label>
                  <md-input v-model="billing_info.amount" readonly/>
                </md-field>
              </div>
              <div v-if="payment_type == 'weekly'" class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label>Amount Weekly</label>
                  <md-input v-model="billing_info.amount_weekly" readonly/>
                </md-field>
              </div>
              <div v-if="payment_type == 'weekly'" class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label>Amount Penalty</label>
                  <md-input v-model="billing_info.amount_penalty" readonly/>
                </md-field>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label>Paid Amount</label>
                  <md-input v-model="billing_info.paid_amount" readonly/>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100">
                <md-field class="md-invalid">
                  <label>Billing Amount</label>
                  <md-input v-model="billing_info.billing_amount" readonly/>
                </md-field>
              </div>
            </div>
          </md-card-content> -->
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import ListDriver from "@/pages/Dashboard/Fms/Cashier/Modal/ListDriver.vue";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { Modal } from "@/components";
import Swal from 'sweetalert2';


// mengirim pesan error ketika required field tidak diisi
extend('businesstype', {
  ...required,
  message: 'Business Type Field is required'
});

extend('drivername', {
  ...required,
  message: 'Driver Name Field is required'
});
extend('paymentmethod', {
  ...required,
  message: 'Payment Method Field is required'
});
extend('cashiername', {
  ...required,
  message: 'Cashier Name Field is required'
});
extend('pool', {
  ...required,
  message: 'Pool Field is required'
});
extend('paymentdate', {
  ...required,
  message: 'Payment Date Field is required'
});
extend('paymentreceive', {
  ...required,
  message: 'Payment Field is required',
  
});
extend('transferno', {
  validate(value,asgs) {
  var validVal =true
  
  if(asgs[0] == 2 && (value == "" || value == null)){
    validVal = false
    
   console.log("bbbbbbb")
  }
    return {
      required: true,
      valid: validVal
    };
  },
  computesRequired: true,
  message: 'Transfer NO Field is required',
  
});
extend('paymenttype', {
  ...required,
  message: 'Payment Type Field is required'
});
  
  export default {
     name: "add-cashier",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver, "list-driver": ListDriver, Modal},

    mixins: [formMixin],

    data: () => ({
      driver_kip_no_text: null,
      driver_name_text: null,
      payment_cashier_name: null,
      payment_method : null,
      payment_pool_id : 0,
      payment_at: (new Date()).toISOString().split('T')[0],
      payment_billing_amount : null,
      payment_transfer_no: null,
      payment_receive_amount : null,
      payment_remark : null,
      payment_type : null,
      payment_type_enable: null,
      payment_ownership: null,
      payment_driver_id:null,
      billing_info: null,
      today : null,
      options_pool_list: null,
      AdditionalFeeHeaders: [
        { text: "Name", value: "name", sortable: false },
        { text: "Type", value: "type", sortable: false },
        { text: "Billing Amount", value: "billing_amount", sortable: false },
        { text: "Paid Amount", value: "paid_amount", sortable: false },
      ],
      ListAdditionalFeeTable: []
    }),

    created() {
      this.getCashier();
      this.getPoolData();
    },

   watch: {
    payment_type: {
      handler: function(newValue) {
        this.payment_billing_amount = null
        this.billing_info = []
        this.billing_info = null
        this.ListAdditionalFeeTable = []
       if(newValue == "dp"){
        this.payment_billing_amount = this.payment_type_enable.biling_dp.billing_amount
        this.billing_info = []
        this.billing_info = this.payment_type_enable.biling_dp
      }
      else if(newValue == "weekly"){
         this.payment_billing_amount = this.payment_type_enable.biling_spj.billing_amount
         this.billing_info = []
         this.billing_info = this.payment_type_enable.biling_spj
      }
      else if(newValue == "additional_fee"){
        //  this.payment_billing_amount = this.payment_type_enable.biling_spj.billing_amount
        //  this.billing_info = []
        //  this.billing_info = this.payment_type_enable.biling_spj
         this.payment_billing_amount = 0
         this.billing_info = []
         this.billing_info = this.payment_type_enable.biling_additional_fee
         this.ListAdditionalFeeTable = this.payment_type_enable.biling_additional_fee


      }
      },
      deep: true
    }
   },
  
    methods: {

      async getCashier(){

        this.me = await this.$store.getters["profile/me"]
        this.payment_cashier_name = this.me.name

      },
      formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

      findDriver(){
      this.$refs.modalListDriver.openModal();
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    async getPoolData() {
      await this.$store.dispatch("workshop_pool/list")
      this.options_pool_list = await this.$store.getters["workshop_pool/list"];
    },

    CloseList(){
      this.$refs.modalListDriver.closeModal();
    },
    
    //fungsi saat memilih row di table additional fee
    onSelectListAdditionalFee(item) {

      this.payment_billing_amount = item.billing_amount
        this.billing_info = []
        this.billing_info = item
    },


  async modalCloseListDriver(data){
      
       this.payment_driver_id = null
       this.driver_name_text = null
       this.driver_kip_no_text = null
       this.payment_type_enable = null
       this.payment_type = null

      if(data.id){
        this.payment_driver_id = data.id
        this.driver_name_text = data.driver_name
        this.driver_kip_no_text = data.driver_kip_no_text
           
        await this.$store.dispatch("fms_driver/bill_payment",data.id);
        var data_biling =  await this.$store.getters["fms_driver/driver"];
        this.payment_type_enable = data_biling
          if(data_biling.biling_dp){
            this.payment_type = "dp"
          }
          else if(data_biling.biling_spj){
            this.payment_type = "weekly"
          }
          else if(data_biling.additional_fee){
            this.payment_type = "additional_fee"
          }
      

      //  if( Object.keys(data.biling).length!=0){
         
      //    if(data.biling.biling_dp){
      //    this.payment_type = "dp"
      //     }
      //     else if(data.biling.biling_spj){
      //       this.payment_type = "weekly"
      //     }
      //  }
       
      }
      this.$refs.modalListDriver.closeModal()
    },

    


      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Cashier' })
    },

    
    swalReceiveAmountMoreThanBillingAmount(){
      console.log("asdasd")
      Swal.fire({
            icon: 'error',
            // title: 'Oops...',
            text: 'Payment Amount melebihi dari billing amount',
          })
    },

     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      // if(this.payment_receive_amount > this.payment_billing_amount){
      //   this.swalReceiveAmountMoreThanBillingAmount();
      //   return
      // }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addCashier()
          }
        });
    },


    // fungsi add data
      async addCashier() {
        
        // console.log('this.billing_info.type :'+this.billing_info.type);
        // console.log('payment_driver_business_type :'+payment_driver_business_type);
        var payment_type = null;
        if(this.payment_type == "dp"){
          payment_type = 1
        }
        else if(this.payment_type == "weekly"){
          payment_type = 2
        }
        else if(this.payment_type == "additional_fee"){
          payment_type = 3
        }
         const data = {
          type: "fms_payments",
          payment_driver_id: this.payment_driver_id,
          payment_type: payment_type,
          payment_method: this.payment_method,
          payment_ref_id: this.billing_info.ref_id,
          payment_receive_amount: this.payment_receive_amount,
          payment_remark: this.payment_remark,
          payment_pool_id: this.payment_pool_id,
          payment_at: this.payment_at
        }

   
        try {
        await this.$store.dispatch("fms_cashier/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // await this.$router.replace({name: 'List Cashier'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
<style lang="scss" scoped>
.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
